@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.orders-drawer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 445px;
  height: 100%;
  background-color: @orders-drawer--background-color;
}

.loading-indicator-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .loading-indicator {
    height: 100px;
    width: 100px;
  }
}

.no-orders {
  padding: 15px;
  text-align: center;
}

.fulfillment-plan-notes-widget-wrapper {
  padding: 15px;
}
